import { useMutation, useQueryClient } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { MessageRequest, MessageStatusResponse } from 'pages/admin/supplierMessaging/types'

const { SECURE_BASE_URL } = config!

const amendMessage = async (props: MessageRequest): Promise<MessageStatusResponse> => {
  const { id, message, startDate, startTime, endDate, endTime, remarks } = props

  const { response: amendMessageResponse } = await callAxios<{
    response: MessageStatusResponse
  }>({
    url: `${SECURE_BASE_URL}/modifyMessage`,
    method: 'PATCH',
    data: {
      id,
      message,
      startDate,
      startTime,
      endDate,
      endTime,
      remarks,
      operation: 'update',
    },
  })

  return amendMessageResponse
}

export const useAmendMessage = () => {
  const queryClient = useQueryClient()

  const {
    status: getAmendMessageStatus,
    data: amendMessageData,
    error: getAmendMessageError,
    mutate: mutateAmendMessage,
  } = useMutation<MessageStatusResponse, CustomAxiosError, MessageRequest>(amendMessage, {
    onSuccess: () => {
      queryClient.invalidateQueries('supplierMessages/get')
    },
  })

  return {
    getAmendMessageStatus,
    amendMessageData,
    getAmendMessageError,
    mutateAmendMessage,
  }
}
